// Mobile-only section-context pill. Sits above the chip strip and shows
// the currently-active section heading (driven by useActiveSection). Tap
// opens the SectionSheet. Always renders; CSS gates visibility on
// (max-width: 768px). Tap-only for v1 — drag-up gesture layers later
// without touching this component's contract.

import type { Section } from "../data/types";

export interface SectionPillProps {
  sections: Section[];
  activeSectionId: string | null;
  onOpen: () => void;
}

export function SectionPill({ sections, activeSectionId, onOpen }: SectionPillProps) {
  if (sections.length === 0) return null;
  const active =
    sections.find((s) => s.id === activeSectionId) ?? sections[0];
  return (
    <button
      type="button"
      className="maisight-section-pill"
      onClick={onOpen}
      aria-label="Open section navigator"
      aria-haspopup="dialog"
    >
      <span className="maisight-section-pill-label">
        {active.heading ?? active.id}
      </span>
      <span className="maisight-section-pill-chevron" aria-hidden="true">
        ⌃
      </span>
    </button>
  );
}
